import styled, {css} from 'styled-components';

export interface IJackpotWidgetLogoBoxProps {
    forcePCView?: boolean;
    widgetIsMinimized?: boolean;
};

export const JackpotWidgetLogoBox = styled.img<IJackpotWidgetLogoBoxProps>`
    /* In a widget of 468px wide, logo should be 222px wide */
    width: 47.436%;
    margin: 0rem auto;
    display: block;

    ${({forcePCView}) => !forcePCView && css`
	    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
	        width: 78%;
	        padding-top: 1rem;
	    }
    `}

    ${({widgetIsMinimized}) => widgetIsMinimized && css`
        width: 25%;
        padding-left: 1rem;
    `}
`;
